module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_3.8af0fd50.jpg";